import { useQuery } from "@tanstack/react-query";

import currentIpApi from "../../apis/current_ip";
import { QUERY_KEYS } from "../../constants";

const { CURRENT_IP } = QUERY_KEYS;

const useShowCurrentIp = () =>
  useQuery({
    queryKey: [CURRENT_IP],
    queryFn: () => currentIpApi.show(),
  });

export { useShowCurrentIp };
